import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="w-full max-w-3xl mx-auto flex flex-col gap-6 text-gray-300 leading-relaxed font-sans px-2">
      <h1 className="text-4xl font-extrabold bg-gradient-to-r from-blue-400 to-indigo-400 bg-clip-text text-transparent mb-2">
        Privacy Policy
      </h1>
      <p className="text-sm text-gray-400">Last Updated: May 29, 2026</p>

      <section className="flex flex-col gap-3">
        <h2 className="text-xl font-bold text-gray-100 mt-4">1. Information We Collect</h2>
        <p className="text-sm text-gray-400">
          GetQRPost is built as a 100% privacy-first, client-side application. We do not require account sign-ups, email listings, or personal profiles. All configurations for URLs, Wi-Fi networks, WhatsApp numbers, and emails are processed directly inside your browser. No private QR details or contact information are ever sent to, stored on, or processed by our servers.
        </p>
      </section>

      <section className="flex flex-col gap-3">
        <h2 className="text-xl font-bold text-gray-100 mt-4">2. Cookies and Tracking Technologies</h2>
        <p className="text-sm text-gray-400">
          We use standard technical cookies and local storage tokens to remember your preferences (like your custom color configurations or selected generator tabs) to enhance your user experience. These technical tokens do not contain identifiable personal information.
        </p>
        <p className="text-sm text-gray-400">
          We may partner with third-party service providers (such as Google AdSense and Google Analytics) to show non-intrusive advertisements or gather anonymous usage statistics. These third parties use cookies, web beacons, and persistent identifiers to serve ads based on your visits to this website and other platforms across the internet.
        </p>
      </section>

      <section className="flex flex-col gap-3">
        <h2 className="text-xl font-bold text-gray-100 mt-4">3. Google DoubleClick DART Cookie</h2>
        <p className="text-sm text-gray-400">
          Google is one of our third-party vendors. It uses DART cookies to serve ads to our site visitors based on their visit to getqrpost.com and other sites on the internet. You can choose to decline the use of DART cookies by visiting the Google Ad and Content Network Privacy Policy at the following URL: <a href="https://policies.google.com/technologies/ads" className="text-indigo-400 hover:text-indigo-300 transition-colors" target="_blank" rel="noopener noreferrer">https://policies.google.com/technologies/ads</a>.
        </p>
      </section>

      <section className="flex flex-col gap-3">
        <h2 className="text-xl font-bold text-gray-100 mt-4">4. Third-Party Privacy Policies</h2>
        <p className="text-sm text-gray-400">
          GetQRPost's Privacy Policy does not apply to other advertisers or websites. We advise you to consult the respective Privacy Policies of these third-party ad servers for more detailed information, which may include their instructions on how to opt-out of certain tracking practices.
        </p>
      </section>

      <section className="flex flex-col gap-3">
        <h2 className="text-xl font-bold text-gray-100 mt-4">5. CCPA and GDPR Data Protection Rights</h2>
        <p className="text-sm text-gray-400">
          Because we do not store, upload, or process any personal data on our backend databases, your data is inherently secure and remains entirely within your personal control. If you have questions regarding data privacy or want to opt-out of cookies, you can adjust your standard web browser settings to block third-party cookies or wipe your local browser cache.
        </p>
      </section>

      <section className="flex flex-col gap-3 border-t border-gray-900 pt-6 mt-4">
        <h2 className="text-lg font-bold text-gray-200">Contact Us Regarding Privacy</h2>
        <p className="text-sm text-gray-400">
          If you have any questions about this Privacy Policy, please contact our support team at <a href="mailto:contact@getqrpost.com" className="text-indigo-400 hover:text-indigo-300">contact@getqrpost.com</a>.
        </p>
      </section>
    </div>
  );
}
